import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

function ButtonGroup({
  primary = 'Lưu',
  secondary = 'Hủy',
  primaryOnClick,
  secondaryOnClick,
  className,
  primaryDisabled = false,
}) {
  return (
    <div className={`${className} d-flex justify-content-center`}>
      <Button
        className="mr-1 px-3"
        size="lg"
        color="primary"
        onClick={primaryOnClick}
        disabled={primaryDisabled}
      >
        {primary}
      </Button>
      <Button
        color="none"
        size="lg"
        className="bg-blur-gray color-white px-3"
        onClick={secondaryOnClick}
      >
        {secondary}
      </Button>
    </div>
  );
}

ButtonGroup.propTypes = {
  primary: PropTypes.string,
  secondary: PropTypes.string,
  primaryOnClick: PropTypes.func,
  secondaryOnClick: PropTypes.func,
  className: PropTypes.string,
  primaryDisabled: PropTypes.bool,
};

export default ButtonGroup;
